import * as React from 'react';
import SvgIcon, { IconProps } from '../partials/SvgIcon';

const ArrowDown: React.FC<IconProps> = (props) => {
  const { fill = '#fff', strokeWidth = '1.5', ...rest } = props;
  return (
    <SvgIcon {...rest}>
      <g
        id="icon-chevron-down"
        stroke="none"
        strokeWidth={strokeWidth}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline
          id="Path"
          stroke={fill}
          strokeWidth={strokeWidth}
          transform="translate(16.000000, 16.300000) rotate(-90.000000) translate(-16.000000, -16.300000) "
          points="22.3 28.9 9.7 16.3 22.3 3.7"
        />
      </g>
    </SvgIcon>
  );
};

export default ArrowDown;
